<mat-card>
  <mat-card-header>
    <div mat-card-avatar><i class="fa fa-cog fa-2x"></i></div>
    <mat-card-title>Movimiento Masivo de {{'order_plural' | human}}</mat-card-title>
    <mat-card-subtitle>Programar ejecución de movimientos masivos</mat-card-subtitle>
  </mat-card-header>
  <mat-card-content>
    <div class="filters" [formGroup]="filters">
      <mat-form-field appearance="outline" subscriptSizing="dynamic" class="state-filter">
        <mat-label>Filtrar por estado de la tarea</mat-label>
        <mat-select formControlName="status_ids[]" multiple>
          <mat-option [value]="null" selectAll>Todos</mat-option>
          @for (statusKey of taskStatusesKeys; track statusKey) {
            <mat-option [value]="statusKey">{{ mapStatus(statusKey)?.name }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
    <div class="table-buttons">
      <button mat-icon-button>
        <mat-icon (click)="openForm()" class="primary" matTooltip="Agendar nuevo movimiento masivo">add</mat-icon>
      </button>
      <button mat-icon-button>
        <mat-icon (click)="reload.emit()" matTooltip="Refrescar tabla">refresh</mat-icon>
      </button>
    </div>
    <table class="scheduled-tasks-table" mat-table [dataSource]="dataSource" matSort (matSortChange)="onSortChange($event)">
      <ng-container matColumnDef="run_at">
        <mat-header-cell *matHeaderCellDef mat-sort-header> Hora Ejecución </mat-header-cell>
        <mat-cell *matCellDef="let element"><span [ngClass]="{cancelled: element.status === 'cancelled'}">{{ element.run_at | date: 'd/M/Y HH:mm' }}</span></mat-cell>
      </ng-container>
      <ng-container matColumnDef="statuses_origin">
        <mat-header-cell *matHeaderCellDef>Desde</mat-header-cell>
        <mat-cell *matCellDef="let element" [matTooltip]="displayOriginStatuses(element)">
          {{ displayOriginStatuses(element) | truncate: ["30"]  }}
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="status_target">
        <mat-header-cell *matHeaderCellDef>A</mat-header-cell>
        <mat-cell *matCellDef="let element">
          {{ displayTargetStatus(element) }}
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="rows_affected">
        <mat-header-cell *matHeaderCellDef>Registros Movidos</mat-header-cell>
        <mat-cell *matCellDef="let element">
          {{ element.result_data?.rows_affected ?? '-' }}
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="status">
        <mat-header-cell *matHeaderCellDef> Estado </mat-header-cell>
        <mat-cell *matCellDef="let element">
          <mat-icon class="icon-{{element.status}}" [matTooltip]="mapStatus(element.status).name">circle</mat-icon>
          @if (element.status === 'failed') {
            &nbsp;
            <mat-icon [matTooltip]="element.last_error">help</mat-icon>
          }
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="actions">
        <mat-header-cell *matHeaderCellDef> </mat-header-cell>
        <mat-cell *matCellDef="let element">
          <div class="action-buttons">
            @if (element.status === 'pending') {
              <button
                  mat-icon-button
                  confirm
                  confirmBody="¿Está seguro que desea iniciar la ejecución ahora?"
                  confirmTitle="Ejecutar ahora"
                  (onConfirm)="runNow(element.id)"
                  matTooltip="Ejecutar ahora"
              >
                <mat-icon class="icon-success">play_arrow</mat-icon>
              </button>
              <button
                  mat-icon-button
                  confirm
                  confirmBody="¿Está seguro que desea cancelar la ejecución?"
                  confirmTitle="Cancelar ejecución"
                  (onConfirm)="cancel(element.id)"
                  matTooltip="Cancelar ejecución"
              >
                <mat-icon class="icon-error">close</mat-icon>
              </button>
            }
          </div>
        </mat-cell>
      </ng-container>
      <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
      <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
    </table>
    <div *ngIf="!dataSource" class="empty">Sin resultados encontrados</div>
  </mat-card-content>

  @if (isLoading()) {
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  }
  <mat-paginator
    #paginator
    [length]="totalData"
    [pageSizeOptions]="pageSizes"
    showFirstLastButtons
  ></mat-paginator>
</mat-card>

<ng-template #formTemplate>
  <div mat-dialog-content class="dialog-content">
    <h2 mat-dialog-title>Agendar Nuevo Movimiento Masivo</h2>
    <form [formGroup]="form">
      <div class="form-row">
        <mat-checkbox formControlName="run_now">Ejecutar inmediatamente</mat-checkbox>
        @if (!form.get('run_now').value) {
          
            <app-datetime-picker
              formControlName="run_at"
              [min]="currentTime"
              label="Fecha y hora de ejecución"
            ></app-datetime-picker>
        }
        
        <ng-container formGroupName="payload">
          <mat-form-field floatLabel="always">
            <mat-label>Filtrar por {{'location_plural' | human}}</mat-label>
            <mat-select formControlName="locations_ids" multiple>
              <mat-option [value]="null" selectAll>Todos</mat-option>
              @for (location of locations(); track location.id) {
                <mat-option [value]="location.id">{{ location.name }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
          <mat-form-field floatLabel="always">
            <mat-label>Filtrar por Requerimientos</mat-label>
            <mat-select formControlName="requirements_ids" multiple>
              <mat-option [value]="null" selectAll>Todos</mat-option>
              @for (requirement of requirements(); track requirement.id) {
                <mat-option [value]="requirement.id">{{ requirement.name }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
          <mat-form-field floatLabel="always">
            <mat-label>Filtrar por Trabajos</mat-label>
            <mat-select formControlName="works_ids" multiple>
              <mat-option [value]="null" selectAll>Todos</mat-option>
              @for (work of works(); track work.id) {
                <mat-option [value]="work.id">{{ work.name }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
          <mat-form-field floatLabel="always">
            <mat-label>Desde</mat-label>
            <mat-select formControlName="origin_status_ids" multiple>
              <mat-option *ngFor="let status of statuses()" [value]="status.id">
                {{ status.name }}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field floatLabel="always">
            <mat-label>Hasta</mat-label>
            <mat-select formControlName="target_status_id">
              <mat-option *ngFor="let status of statuses()" [value]="status.id">
                {{ status.name }}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field>
            <mat-label>Umbral (en días)</mat-label>
            <input matInput type="number" [step]="1" [min]="0" formControlName="threshold_days" />
          </mat-form-field>
        </ng-container>
      </div>
      <div class="buttons">
        <button mat-button mat-dialog-close>Cancelar</button>
        <button mat-raised-button class="primary" (click)="save()" [disabled]="!form.valid || saving()">
          @if (saving()) {
            <mat-spinner diameter="20" mode="indeterminate"></mat-spinner>
          }
          @else {
            Guardar
          }
        </button>
      </div>
    </form>
  </div>
</ng-template>
